/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper"; // Updated import
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import LabTestHeader from "./Header/LabTestHeader"; // Updated import
import LabTestFilter from "./Popup/LabTestFilter";
import SaveLabTestPopup from "components/Common/Popup/SaveLabTestPopup";

const LabTestBody = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [labTestList, setLabTestList] = useState([]); // Renamed
  const [rowSelection, setRowSelection] = useState({});
  const [selectedLabTestIds, setSelectedLabTestIds] = useState([]); // Renamed
  const [selectedLabTestId, setSelectedLabTestId] = useState(null); // Renamed
  const [selectedTagId, setSelectedTagId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [doctorObj, setDoctorObj] = useState(null);
  const [clinicObj, setClinicObj] = useState(null);
  const [labTesterObj, setLabTesterObj] = useState(null);

  const getDoctorOrLabtesterDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${userInfo._id}` +
        `?token=${token}`;

      console.log("requestUrl in Doctor or Labtester details", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in user details", response);

      if (response.status && response.data) {
        const data = response.data;

        const userApiObj = {
          _id: data._id,
          company: data.company,
          name: data.name,
          surname: data.surname,
          email: data.email,
          position: data.position,
          address: data.address,
          city: data.city,
          state: data.state,
          country: data.country,
          zipcode: data.zipcode,
          phone: data.phone,
          rank: data.rank,
          costperhour: data.costperhour,
          mincostperhour: data.mincostperhour,
          taglist: data.tags,
          image: data.userimage,
          fullname: data.userfullname,
          rolestring: data.userrole?.label,
          label: data.userfullname,
          value: data._id,
        };

        if (userInfo.role.slug === "DOCTOR") {
          setDoctorObj(userApiObj);
        } else if (userInfo.role.slug === "LAB_TECHNICIAN") {
          setLabTesterObj(userApiObj);
        }
      }
    } catch (error) {
      console.log(error.message);
    } finally {
    }
  };

  const getProviderClinicList = async () => {
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_COMPANY_LIST + `?token=${token}`;
      const response = await getData(requestUrl);

      console.log("response in getProviderClinics", response);

      if (response.status && response.data) {
        setClinicObj(response.data[0]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // get all lab tests
  const getAllLabTests = async () => {
    // Renamed
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_MEDICAL_TEST + `?token=${token}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      // console.log("requestUrl in lab test list------->", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setLabTestList(response.data); // Renamed
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // bulk update lab tests
  const updateBulkLabTestsHandler = async () => {
    // Renamed
    if (selectedLabTestIds.length > 0) {
      // Renamed
      try {
        const labTestListToBeUpdate = labTestList.filter(
          (
            item // Renamed
          ) => selectedLabTestIds.includes(item._id) // Renamed
        );

        let labTestData = {
          // Renamed
          medicaltestlist: labTestListToBeUpdate, // Renamed
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_MEDICAL_TEST +
          `?token=${token}`;

        const response = await putData(requestURL, labTestData); // Renamed

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedLabTestIds([]); // Renamed
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one lab test"); // Updated message
      setMessageType("error");
    }
    setShowAlert(true);
  };

  // bulk delete lab tests
  const deleteBulkLabTestsHandler = async () => {
    // Renamed
    if (selectedLabTestIds.length > 0) {
      // Renamed
      try {
        const labTestListToBeDelete = labTestList.filter(
          (
            item // Renamed
          ) => selectedLabTestIds.includes(item._id) // Renamed
        );

        let labTestData = {
          // Renamed
          medicaltestlist: labTestListToBeDelete, // Renamed
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_TEST +
          `?token=${token}`;

        const response = await putData(requestURL, labTestData); // Renamed

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setLabTestList(
              (
                prevList // Renamed
              ) =>
                prevList.filter(
                  (item) => !selectedLabTestIds.includes(item._id)
                ) // Renamed
            );
            setSelectedLabTestIds([]); // Renamed
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one lab test"); // Updated message
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from lab test
  const removeTagFromLabTest = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_MEDICAL_TEST;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedLabTestId(null);
      }, 1000);
    }
  };

  // After any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setLabTestList((prevList) => mergeListById(prevList, data)); // Renamed
    }, 1000);
  };

  const resetFilterData = () => {
    setSelectedLabTestIds([]); // Renamed
    setRowSelection({});
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  // useEffect(() => {
  //   getAllLabTests(); // Renamed
  // }, []);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllLabTests();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllLabTests();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveLabTestOffCanvas" // Updated target
            aria-controls="saveLabTestOffCanvas" // Updated target
            onClick={() => {
              setSelectedLabTestId(row.original._id); // Renamed
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Test Name",
        accessorKey: "name",
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedLabTestId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromLabTest([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedLabTestId &&
                          selectedLabTestId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedLabTestIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Code",
        accessorKey: "code",
      },
      {
        header: "LOINC Code",
        accessorKey: "loinccode",
      },
      {
        header: "Test Type",
        accessorKey: "categoryname",
      },
      // assigned person name
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
      // doctor name
      {
        header: "Doctor Name",
        accessorKey: "doctorname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      // clinic name
      {
        header: "Clinic Name",
        accessorKey: "clinicname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.clinicname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      // lab tester
      {
        header: "Lab Tester Name",
        accessorKey: "providername",
        Cell: ({ row }) => (
          <div
            className={
              row.original.providername === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.providerimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.providerimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.providername}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Order Date",
        accessorKey: "testorderdate",
      },
      {
        header: "Test Date",
        accessorKey: "testcompleteddate",
      },
      {
        header: "Result Date",
        accessorKey: "resultcompleteddate",
      },
      {
        header: "Result",
        accessorKey: "testresult",
      },
      {
        header: "Status",
        accessorKey: "teststatus",
      },
    ],
    [selectedLabTestId, selectedTagId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedLabTestIds(selectedIdsArray); // Renamed
    } else {
      setSelectedLabTestIds([]); // Renamed
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    if (
      userInfo?.role?.slug === "DOCTOR" ||
      userInfo?.role?.slug === "LAB_TECHNICIAN"
    ) {
      getDoctorOrLabtesterDetails();
    } else if (userInfo?.role?.slug === "CUSTOMER") {
      getProviderClinicList();
    }
  }, []);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_LAB_TEST_MANAGEMENT") // Updated module access
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Lab Test")} // Updated active option
          />
          <div className="container-fluid px-lg-5">
            <LabTestHeader // Renamed
              selectedItemIds={selectedLabTestIds} // Renamed
              updateBulkHandler={updateBulkLabTestsHandler} // Renamed
              reloadList={resetFilterData} // Renamed
              jsonFilterQuery={jsonFilterQuery}
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={labTestList} // Renamed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* popup and modals */}
          <SaveLabTestPopup
            selectedLabTestId={selectedLabTestId} // Renamed
            setSelectedLabTestId={setSelectedLabTestId} // Renamed
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            doctorObj={doctorObj}
            labTesterObj={labTesterObj}
            clinicObj={clinicObj}
          />

          <LabTestFilter
            columns={columns}
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            moduleSlug="labtest"
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <AssignUserModal
            moduleName="medicaltest"
            afterModalClose={afterActionClose}
            selectedIds={selectedLabTestIds} // Renamed
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedLabTestIds([]); // Renamed
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkLabTestsHandler} // Renamed
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedLabTestIds([]); // Renamed
            }}
            moduleName={t("Lab Test")} // Updated module name
          />

          <AddLabelModal
            moduleName="medicaltest"
            selectedIds={selectedLabTestIds} // Renamed
            afterTagModalClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedLabTestIds([]); // Renamed
            }}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default LabTestBody;
